import { observable, action, computed } from 'mobx';
import Alert from 'react-s-alert';

import { Model, ArrayApp, App, AppRegistry, ModelRegistry } from 'core/index';

// eslint-disable-next-line
import { CompleteTagsQuery } from 'apps/tag/gql'; // Hack: need a proper registry system

import i18next from 'i18next';

export class TagModel extends Model {
  static registryName = 'TagModel';
  @observable name;
}
ModelRegistry.add(TagModel);

class TagApp extends App {
  static registryName = 'TagApp';
  static Model = TagModel;
  @action UpdateName = name => {
    this.name = name;
  };
}

export class TagsApp extends ArrayApp {
  static registryName = 'TagsApp';
  static ElementApp = TagApp;
  @computed get loading() {
    return this.manager.loading;
  }

  @computed get editing() {
    return this.parent.editing;
  }

  @computed get deletedCount() {
    return this.apps.filter(tag => tag?.deleted).length;
  }

  @computed get isEmpty() {
    return this.apps.filter(tag => !tag?.deleted).length === 0;
  }

  // FIXME
  // eslint-disable-next-line
  getDup(tag) {
    // eslint-disable-next-line
    for (const t of this) {
      if (t.name === tag.name) {
        return t;
      }
    }
  }

  @action Add = tag => {
    const dup = this.getDup(tag);
    if (dup) {
      if (dup.deleted) {
        dup.deleted = false;
      } else {
        const tagName = tag.name;
        Alert.error(
          i18next.t("No need to add '{{tagName}}' twice!", { tagName }),
        );
      }
    } else {
      this.push(tag);
    }
  };

  @action Delete = tag => {
    // this.tag.upstream.id !== this.tag.id
    if (tag.id === undefined) {
      this.remove(tag);
    } else {
      tag.deleted = true;
    }
  };
}
AppRegistry.add(TagsApp);
